import { IState } from '../../../store';

export const getOfferFoldersCount = (state: IState) => {
  return state.offerData.offerFoldersCount;
};
